import { authFetch } from './fetchWithAuth'
import type { Kostenuebernahme } from '../types/kostenuebernahme'

/** Phase H — KÜ-Aufgaben des eingeloggten Portal-Users. */
export interface ZuzahlerTasksResponse {
  items: Kostenuebernahme[]
}

export interface ZuzahlerTaskDetailResponse {
  item: Kostenuebernahme
}

export interface NeueFirmaDto {
  Name: string
  AddressLine1: string
  Postalcode: string
  City: string
  UstId?: string
  Hrnummer?: string
}

/** Submit-Body fuer /api/zuzahler/tasks/:id/submit.
 *  signedIp + signedUserAgent werden vom BFF ergaenzt — niemals hier setzen. */
export interface PortalSubmitDto {
  AnteilProzent: number
  Zahlungsart: 'einmalig' | 'monatlich'
  Zahlungsweise: 'ueberweisung' | 'sepa'
  RechnungFirma: string
  RechnungAdresszusatz?: string
  RechnungApName: string
  RechnungEmailAp: string
  RechnungEmailInvoice?: string
  RechnungAbteilung?: string
  RechnungTelefon?: string
  RechnungStrasse: string
  RechnungHausnummer: string
  RechnungPlz: string
  RechnungOrt: string
  NeueFirma?: NeueFirmaDto
}

export async function listTasks(): Promise<ZuzahlerTasksResponse> {
  const r = await authFetch('/api/zuzahler/tasks')
  if (!r.ok) throw new Error(`Aufgaben laden fehlgeschlagen: ${r.status}`)
  return r.json()
}

export async function getTask(id: number): Promise<ZuzahlerTaskDetailResponse> {
  const r = await authFetch(`/api/zuzahler/tasks/${id}`)
  if (r.status === 404) throw new Error('Diese Aufgabe ist nicht verfügbar.')
  if (!r.ok) throw new Error(`Detail laden fehlgeschlagen: ${r.status}`)
  return r.json()
}

export async function submitTask(id: number, dto: PortalSubmitDto): Promise<void> {
  const r = await authFetch(`/api/zuzahler/tasks/${id}/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(dto),
  })
  if (!r.ok) {
    let msg = `Senden fehlgeschlagen: ${r.status}`
    try {
      const data = await r.json()
      if (data?.error) msg = data.error
      else if (data?.detail) msg = typeof data.detail === 'string' ? data.detail : JSON.stringify(data.detail)
    } catch {
      /* ignore */
    }
    throw new Error(msg)
  }
}
